import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const VERDE = '#1F6A2D';

export default function MeuPerfil() {
  const { user } = useAuth();
  const [form, setForm] = useState({ senha_atual: '', nova_senha: '', confirmar: '' });
  const [feedback, setFeedback] = useState(null);
  const [salvando, setSalvando] = useState(false);
  const [mostrarSenhas, setMostrarSenhas] = useState(false);

  const iniciais = (user?.nome || '?')
    .split(/\s+/).filter(Boolean).slice(0, 2)
    .map(s => s[0]?.toUpperCase()).join('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedback(null);
    if (form.nova_senha.length < 6) {
      setFeedback({ tipo: 'danger', msg: 'A nova senha deve ter pelo menos 6 caracteres.' });
      return;
    }
    if (form.nova_senha !== form.confirmar) {
      setFeedback({ tipo: 'danger', msg: 'A confirmação não coincide com a nova senha.' });
      return;
    }
    if (form.nova_senha === form.senha_atual) {
      setFeedback({ tipo: 'danger', msg: 'A nova senha precisa ser diferente da atual.' });
      return;
    }

    setSalvando(true);
    try {
      const endpoint = user.tipo === 'arquiteto'
        ? `/arquitetos/${user.id}/senha`
        : `/usuarios/${user.id}/senha`;
      await api.post(endpoint, {
        senha_atual: form.senha_atual,
        nova_senha: form.nova_senha,
      });
      setFeedback({ tipo: 'success', msg: 'Senha alterada com sucesso.' });
      setForm({ senha_atual: '', nova_senha: '', confirmar: '' });
    } catch (err) {
      setFeedback({ tipo: 'danger', msg: err.response?.data?.error || 'Erro ao alterar senha.' });
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div>
      <h4 className="fw-bold mb-1">
        <i className="bi bi-person-circle me-2" style={{ color: VERDE }}></i>
        Meu Perfil
      </h4>
      <p className="text-muted mb-4">Gerencie suas informações de acesso</p>

      <div className="row g-4">
        <div className="col-12 col-md-5 col-lg-4">
          <div className="card p-4">
            <div className="d-flex flex-column align-items-center text-center mb-3">
              <div style={{
                width: 88,
                height: 88,
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #1F6A2D 0%, #1F6A2D 100%)',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '2rem',
                fontWeight: 700,
                marginBottom: 12,
                boxShadow: '0 4px 12px rgba(46,152,70,0.25)',
              }}>
                {iniciais}
              </div>
              <h5 className="fw-bold mb-1" style={{ color: '#1F6A2D' }}>{user?.nome || 'Usuário'}</h5>
              {user?.perfil_nome && <span className="badge-filial">{user.perfil_nome}</span>}
            </div>

            <hr className="my-3" style={{ borderColor: 'var(--borda)' }} />

            <div className="mb-2">
              <div className="text-muted" style={{ fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                Identificador
              </div>
              <div className="fw-semibold">{user?.username || '—'}</div>
            </div>
            {user?.tipo && (
              <div>
                <div className="text-muted" style={{ fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
                  Tipo de acesso
                </div>
                <div className="fw-semibold">
                  {user.tipo === 'arquiteto' ? 'Arquiteto parceiro' : 'Equipe Centrão'}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="col-12 col-md-7 col-lg-6">
          <div className="card p-4">
            <h6 className="fw-bold mb-1" style={{ color: VERDE }}>
              <i className="bi bi-shield-lock me-2"></i>Alterar Senha
            </h6>
            <p className="text-muted mb-4" style={{ fontSize: '0.88rem' }}>
              Use pelo menos 6 caracteres. Combine letras e números pra ficar mais segura.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Senha atual</label>
                <input
                  className="form-control"
                  type={mostrarSenhas ? 'text' : 'password'}
                  value={form.senha_atual}
                  onChange={(e) => setForm({ ...form, senha_atual: e.target.value })}
                  autoComplete="current-password"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Nova senha</label>
                <input
                  className="form-control"
                  type={mostrarSenhas ? 'text' : 'password'}
                  value={form.nova_senha}
                  onChange={(e) => setForm({ ...form, nova_senha: e.target.value })}
                  autoComplete="new-password"
                  minLength={6}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Confirmar nova senha</label>
                <input
                  className="form-control"
                  type={mostrarSenhas ? 'text' : 'password'}
                  value={form.confirmar}
                  onChange={(e) => setForm({ ...form, confirmar: e.target.value })}
                  autoComplete="new-password"
                  required
                />
              </div>

              <div className="form-check mb-4">
                <input
                  id="mostrar-senhas"
                  type="checkbox"
                  className="form-check-input"
                  checked={mostrarSenhas}
                  onChange={(e) => setMostrarSenhas(e.target.checked)}
                />
                <label htmlFor="mostrar-senhas" className="form-check-label" style={{ fontSize: '0.9rem' }}>
                  Mostrar senhas
                </label>
              </div>

              {feedback && (
                <div className={`alert alert-${feedback.tipo} py-2`}>
                  <i className={`bi ${feedback.tipo === 'success' ? 'bi-check-circle' : 'bi-exclamation-circle'} me-2`}></i>
                  {feedback.msg}
                </div>
              )}

              <button type="submit" className="btn-primary-arq" disabled={salvando}>
                {salvando
                  ? <><span className="spinner-border spinner-border-sm me-2"></span>Salvando...</>
                  : <><i className="bi bi-check2 me-2"></i>Salvar nova senha</>
                }
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
